import OrderHandler from "../OrderHandler";
import Mediator from "../../../Utilities/Mediator";
import DatePicker from "../../../DomUtilities/DatePicker";
import { DateTime } from 'luxon';
import Item from "../../../Models/Item";
import Service from "../../../Models/Service";
import Variant from "../../../Models/Variant";
import { ServiceType } from "../../../Models/ServiceType";
import { createItemServiceVariantTiles } from "../ChooseService/VariantCartTile";

export default class DeliveryDatePicker {
	private dateInput: HTMLInputElement;
	private dateError: HTMLParagraphElement;
	private datePicker: DatePicker;
	private readonly INPUT_BORDER_COLOR: string = "#d80027";
	private readonly Error_BORDER_COLOR: string = "#bdbdbd";
	expressDeliveryAlertBtn: HTMLButtonElement;

	constructor() {
		this.dateInput = document.querySelector('#date');
		this.expressDeliveryAlertBtn = document.querySelector('.bill-total button.btn-close');
		if (!this.dateInput) {
			OrderHandler.order.deliveryDate = DateTime.now().toJSDate();
			Mediator.emit("orderStateChanged");
			this.expressDeliveryAlertBtn.click();
		} else {
			this.init();
		}
	}

	private init() {
		this.dateError = document.querySelector('#date + img + p');
		this.datePicker = new DatePicker("#date", this.dateInput.dataset.lang);

		this.datePicker.setProperty("disable",
			[
				date => date.getDay() === 0
			]);
		this.datePicker.setProperty("minDate", new Date());
		this.datePicker.setProperty("closeOnSelect", true);

		this.validateDate();
		this.addOnChangeListener();
	}

	private validateDate() {
		if (this.datePicker.isValid) {
			this.dateError.style.opacity = "0";
			this.dateError.style.marginBottom = "0px";
			this.dateInput.style.borderColor = this.Error_BORDER_COLOR;
			OrderHandler.order.deliveryDate = this.datePicker.DateValue;
			this.expressDeliveryAlertBtn.click();
		} else {
			this.dateError.style.opacity = "1";
			this.dateError.style.marginBottom = "15px";
			this.dateInput.style.borderColor = this.INPUT_BORDER_COLOR;
			OrderHandler.order.deliveryDate = null;
		}
		Mediator.emit("orderStateChanged");
	}

	private addOnChangeListener() {
		this.dateInput.onchange = () => {
			if (this.isExpressDelivery) {
				this.addExpressDelivery();
			} else {
				this.removeExpressDelivery();
			}
			this.validateDate();
			Mediator.emit("orderUpdated");
			createItemServiceVariantTiles();
			OrderHandler.updateCartIconCount();
		}
	}

	private get isExpressDelivery(): boolean {
		const today = new Date();
		const thresholdDate = this.getThresholdDate(today);
		const selectedDate = this.datePicker.DateValue;
		return selectedDate.getTime() <= thresholdDate.getTime()
	}

	private getThresholdDate(today: Date): Date {
		var expressDays = today.getDay() === 5 || today.getDay() === 6 ? 4 : 3
		const date = new Date(today.getFullYear(), today.getMonth(), today.getDate() + expressDays);

		return date;
	}

	private addExpressDelivery() {
		if (OrderHandler.hasExpressDelivery) {
			return;
		}

		const variant = new Variant();
		variant.id = OrderHandler.EXPRESS_DELIVERY_ID;
		variant.name = "Ekspres levering";
		variant.baseCost = OrderHandler.EXPRESS_DELIVERY_COST / 1.25;
		variant.cost = OrderHandler.EXPRESS_DELIVERY_COST;
		variant.productionTime = 1;
		const service = new Service();
		service.id = service.serviceTypeId = OrderHandler.EXPRESS_DELIVERY_ID;
		service.name = "Service";
		service.type = ServiceType.None;
		service.variants = [variant];
		const item = new Item();
		item.id = item.itemId = item.itemTypeId = OrderHandler.EXPRESS_DELIVERY_ID;
		item.name = "Express delivery";
		item.count = OrderHandler.totalItemsCountExceptExpressDelivery;
		item.services = [service];
		OrderHandler.order.items.push(item);
	}

	private removeExpressDelivery() {
		if (OrderHandler.hasExpressDelivery) {
			const index = OrderHandler.order.items.findIndex(i => i.id === OrderHandler.EXPRESS_DELIVERY_ID);
			OrderHandler.order.items.splice(index, 1);
		}
	}
}
